export default {"src":"/_next/static/media/notice-message-illustrator.5406fcdb.svg","height":62,"width":64};